import { render, staticRenderFns } from "./CmgAccountModalMenuLinks.vue?vue&type=template&id=e67a0f56&scoped=true&lang=pug"
import script from "./cmg-account-modal-menu-links.ts?vue&type=script&lang=ts&external"
export * from "./cmg-account-modal-menu-links.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAccountModalMenuLinks.vue?vue&type=style&index=0&id=e67a0f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67a0f56",
  null
  
)

export default component.exports